import { createFileRoute } from '@tanstack/react-router';

import { BillingGroupContainer } from '@/features/billing-groups/containers/[billing-group-id]';

export const Route = createFileRoute('/_layout/billing-groups/$billingGroupId')({
  component: BillingGroupContainer,
});
